module.exports = __webpack_public_path__ + "img/yellowgold@2x.35c985b.jpg";